<script setup lang="ts">
defineEmits<{ (e: 'click'): void }>();

defineProps<{
  text: string;
}>();
</script>

<template>
  <button
    type="button"
    class="flex h-10 w-[200px] cursor-pointer items-center justify-center gap-2 rounded-full border border-gray-300 bg-white px-2 py-6 text-sm font-semibold text-gray-900"
    @click="$emit('click')"
  >
    {{ text }}
  </button>
</template>
